import { computed, toRef, getCurrentInstance } from 'vue';
import { RootState } from './types';

export function useRootStore() {
    const vm = getCurrentInstance();

    const state = computed(() => vm.proxy.$store.state as RootState);
    const version = computed(() => state.value.version);
    const message = computed(() => state.value.message);
    const error = computed(() => state.value.error);
    const errorCode = computed(() => state.value.errorCode);
    const errorMsg = computed(() => state.value.errorMsg);
    const process = computed(() => state.value.process);
    const embedded = computed(() => state.value.embedded);

    /**
     * トーストメッセージを消す
     */
    async function dealMessage() {
        await vm.proxy.$store.dispatch('dealMessage');
    }
    /**
     * システムエラーまたは予期せぬエラーを消す
     */
    async function dealError() {
        await vm.proxy.$store.dispatch('dealError');
    }

    return {
        version,
        message,
        error,
        errorCode,
        errorMsg,
        process,
        embedded,
        dealMessage,
        dealError,
    };
}
